import nomenclatureApi from '@/api/nomenclature';

const state = {
    isLoading:null,
    nomenclature:null,
    groupsList:null,
    nomenclature_segment_unit:null,
    nomenclature_segment:null,
    datamark:null
}

export const mutationTypes = {
    getNomenclatureStart: '[getNomenclature] Get Nomenclature Full start',
    getNomenclatureSuccess: '[getNomenclature] Get Nomenclature Full success',
    getNomenclatureFailure: '[getNomenclature] Get Nomenclature Full failure',

    getOnlineGroupsStart: '[getOnlineGroups] Get Online Groups start',
    getOnlineGroupsSuccess: '[getOnlineGroups] Get Online Groups success',
    getOnlineGroupsFailure: '[getOnlineGroups] Get Online Groups failure',


    saveNomenclatureStart: '[saveNomenclature] Save Nomenclature start',
    saveNomenclatureSuccess: '[saveNomenclature] Save Nomenclature success',
    saveNomenclatureFailure: '[saveNomenclature] Save Nomenclature failure',

    getNomenclatureSegmentsStart: '[nomenclature_segment] Get Nomenclature Segments start',
    getNomenclatureSegmentsSuccess: '[nomenclature_segment] Get Nomenclature Segments success',
    getNomenclatureSegmentsFailure: '[nomenclature_segment] Get Nomenclature Segments failure',

    createNomenclatureSegmentsStart: '[nomenclature_segment] Create Nomenclature Segments start',
    createNomenclatureSegmentsSuccess: '[nomenclature_segment] Create Nomenclature Segments success',
    createNomenclatureSegmentsFailure: '[nomenclature_segment] Create Nomenclature Segments failure',

    getNomenclatureSegmentsUnitStart: '[nomenclature_segment_unit] Get Nomenclature Segments Unit start',
    getNomenclatureSegmentsUnitSuccess: '[nomenclature_segment_unit] Get Nomenclature Segments Unit success',
    getNomenclatureSegmentsUnitFailure: '[nomenclature_segment_unit] Get Nomenclature Segments Unit failure',

    createNomenclatureSegmentsUnitStart: '[nomenclature_segment_unit] Create Nomenclature Segments Unit start',
    createNomenclatureSegmentsUnitSuccess: '[nomenclature_segment_unit] Create Nomenclature Segments Unit success',
    createNomenclatureSegmentsUnitFailure: '[nomenclature_segment_unit] Create Nomenclature Segments Unit failure',

    checkDataMarkStart:
    "[checkDataMark] Check Data Mark start",
  checkDataMarkSuccess:
    "[checkDataMark] Check Data Mark success",
  checkDataMarkFailure:
    "[checkDataMark] Check Data Mark failure",
    
}

export const nomenclatureActionTypes = {
    getNomenclature: '[getNomenclature] Get Nomenclature Full',
    getOnlineGroups: '[getOnlineGroups] Get Online Groups',
    saveNomenclature: '[saveNomenclature] Save Nomenclature',
    getNomenclatureSegments: '[nomenclature_segment] Get Nomenclature Segments',
    createNomenclatureSegments: '[nomenclature_segment] Create Nomenclature Segments',
    getNomenclatureSegmentsUnit: '[nomenclature_segment_unit] Get Nomenclature Segments Unit',
    createNomenclatureSegmentsUnit: '[nomenclature_segment_unit] Create Nomenclature Segments Unit',
    checkDataMark:"[checkDataMark] Check Data Mark"
}

const mutations = {

    [mutationTypes.getNomenclatureStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureSuccess](state, payload) {
        state.isLoading = false
        state.nomenclatureList = payload
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getOnlineGroupsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getOnlineGroupsSuccess](state, payload) {
        state.isLoading = false
        state.groupsList = payload
        state.validationErrors = null
    },
    [mutationTypes.getOnlineGroupsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.saveNomenclatureStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.saveNomenclatureSuccess](state, payload) {
        state.isLoading = false
        state.nomenclature = payload
        state.validationErrors = null
    },
    [mutationTypes.saveNomenclatureFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    }, // ----------------------------------------------------------------------------------------------

    [mutationTypes.getNomenclatureSegmentsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureSegmentsSuccess](state, payload) {
        state.isLoading = false
        state.nomenclature_segment = payload
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureSegmentsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createNomenclatureSegmentsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.createNomenclatureSegmentsSuccess](state, payload) {
        state.isLoading = false
        state.nomenclature_segment = payload
        state.validationErrors = null
    },
    [mutationTypes.createNomenclatureSegmentsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
    
    [mutationTypes.getNomenclatureSegmentsUnitStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureSegmentsUnitSuccess](state, payload) {
        state.isLoading = false
        state.nomenclature_segment_unit = payload
        state.validationErrors = null
    },
    [mutationTypes.getNomenclatureSegmentsUnitFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createNomenclatureSegmentsUnitStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.createNomenclatureSegmentsUnitSuccess](state, payload) {
        state.isLoading = false
        state.nomenclature_segment_unit = payload
        state.validationErrors = null
    },
    [mutationTypes.createNomenclatureSegmentsUnitFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.checkDataMarkStart](state) {
        state.isLoading = true;
        state.validationErrors = null;
        state.datamark = null;
      },
      [mutationTypes.checkDataMarkSuccess](state, payload) {
        state.isLoading = false;
        state.datamark = payload;
        state.validationErrors = null;
      },
      [mutationTypes.checkDataMarkFailure](state, payload) {
        state.isLoading = false;
        state.validationErrors = payload;
      },
    
    
}

const actions = {
   
    [nomenclatureActionTypes.getNomenclature](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNomenclatureStart)
            nomenclatureApi
                .getNomenclature(data)
                .then(response => {
                    context.commit(mutationTypes.getNomenclatureSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNomenclatureFailure,response)
                })
        })
    },
    [nomenclatureActionTypes.getOnlineGroups](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getOnlineGroupsStart)
            nomenclatureApi
                .getOnlineGroups(data)
                .then(response => {
                    context.commit(mutationTypes.getOnlineGroupsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getOnlineGroupsFailure,response)
                })
        })
    },
    [nomenclatureActionTypes.saveNomenclature](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saveNomenclatureStart)
            nomenclatureApi
                .saveNomenclature(data)
                .then(response => {
                    context.commit(mutationTypes.saveNomenclatureSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saveNomenclatureFailure,response)
                })
        })
    }, //----------------------------------------------------------------------------------------------------------------------------
    [nomenclatureActionTypes.getNomenclatureSegments](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNomenclatureSegmentsStart)
            nomenclatureApi
                .getNomenclatureSegments(data)
                .then(response => {
                    context.commit(mutationTypes.getNomenclatureSegmentsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNomenclatureSegmentsFailure,response)
                })
        })
    },
    [nomenclatureActionTypes.createNomenclatureSegments](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createNomenclatureSegmentsStart)
            nomenclatureApi
                .createNomenclatureSegments(data)
                .then(response => {
                    context.commit(mutationTypes.createNomenclatureSegmentsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createNomenclatureSegmentsFailure,response)
                })
        })
    },
    [nomenclatureActionTypes.getNomenclatureSegmentsUnit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNomenclatureSegmentsUnitStart)
            nomenclatureApi
                .getNomenclatureSegmentsUnit(data)
                .then(response => {
                    context.commit(mutationTypes.getNomenclatureSegmentsUnitSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNomenclatureSegmentsUnitFailure,response)
                })
        })
    },
    [nomenclatureActionTypes.createNomenclatureSegmentsUnit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createNomenclatureSegmentsUnitStart)
            nomenclatureApi
                .createNomenclatureSegmentsUnit(data)
                .then(response => {
                    context.commit(mutationTypes.createNomenclatureSegmentsUnitSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createNomenclatureSegmentsUnitFailure,response)
                })
        })
    },

    [nomenclatureActionTypes.checkDataMark](context, data) {
        return new Promise((resolve) => {
          context.commit(mutationTypes.checkDataMarkStart);
          nomenclatureApi
            .checkDataMark(data)
            .then((response) => {
              context.commit(
                mutationTypes.checkDataMarkSuccess,
                response,
              );
              resolve(response);
            })
            .catch((response) => {
              context.commit(
                mutationTypes.checkDataMarkFailure,
                response,
              );
            });
        });
      },
}

export default {
    state,
    actions,
    mutations
}